import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { Facebook, MapPin, Instagram, Send } from "lucide-react";
import NewsletterForm from "@/components/NewsletterForm";

export default function Footer() {
  const { settings } = useSite();
  return (
    <footer className="border-t border-[#D4AF37]/15 mt-24 bg-[#0B0A0C]">
      <div className="max-w-7xl mx-auto px-6 py-12 sm:py-14 grid gap-10 sm:grid-cols-2 md:grid-cols-4">
        <div>
          <span className="font-display text-2xl gold-text tracking-[0.15em]">AFRODITE</span>
          <p className="text-sm text-[#6E6865] mt-4 leading-relaxed max-w-xs">
            Club privé e spa naturista in Puglia. Ingresso riservato ai soci maggiorenni.
          </p>
          {settings.address && (
            <p className="flex items-center gap-2 text-sm text-[#A39E9B] mt-4">
              <MapPin className="w-4 h-4 text-[#D4AF37]" /> {settings.address}
            </p>
          )}
        </div>
        <div>
          <p className="overline mb-4">Navigazione</p>
          <ul className="space-y-2 text-sm text-[#A39E9B]">
            <li><Link to="/club-prive" className="hover:text-[#D4AF37]">Club Privé</Link></li>
            <li><Link to="/spa-naturista" className="hover:text-[#D4AF37]">Spa Naturista</Link></li>
            <li><Link to="/gallery" className="hover:text-[#D4AF37]">Gallery</Link></li>
            <li><Link to="/info" className="hover:text-[#D4AF37]">Chi Siamo &amp; Privacy</Link></li>
            <li><Link to="/contatti" className="hover:text-[#D4AF37]">Contatti</Link></li>
          </ul>
        </div>
        <div>
          <p className="overline mb-4">Contatti</p>
          <p className="text-sm text-[#A39E9B]">Tel: <span className="text-[#FBF8F5]">{settings.phone || "333 1512490"}</span></p>
          <p className="text-sm text-[#A39E9B] mt-1">{settings.opening_hours}</p>
          {settings.facebook_url && (
            <a href={settings.facebook_url} target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-4 text-sm text-[#D4AF37] hover:text-[#F3E5AB]">
              <Facebook className="w-4 h-4" /> Facebook
            </a>
          )}
          {settings.instagram_url && (
            <a href={settings.instagram_url} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-1"
              className="flex items-center gap-2 mt-3 text-sm text-[#D4AF37] hover:text-[#F3E5AB]">
              <Instagram className="w-4 h-4" /> @{settings.instagram_url.replace(/\/$/, "").split("/").pop()}
            </a>
          )}
          {settings.telegram && (
            <a href={`https://t.me/+${settings.telegram}`} target="_blank" rel="noopener noreferrer" data-testid="footer-telegram"
              className="flex items-center gap-2 mt-3 text-sm text-[#D4AF37] hover:text-[#F3E5AB]">
              <Send className="w-4 h-4" /> Telegram
            </a>
          )}
        </div>
        <NewsletterForm />
      </div>
      <div className="border-t border-white/5 py-5 pb-24 sm:pb-5 text-center text-xs text-[#6E6865] px-4">
        © {new Date().getFullYear()} Afrodite Club Privé &amp; Spa Naturista · Puglia — Contenuti riservati ai maggiori di 18 anni
      </div>
    </footer>
  );
}
